import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { BarChart3, Users, FileText } from 'lucide-react';
import { SupervisorService } from '../../services/supervisorService';

const SupervisorDashboard = () => {
  const navigate = useNavigate();

  const { data: operationsData, isLoading } = useQuery({
    queryKey: ['supervisorOperations'],
    queryFn: () => SupervisorService.getOperationsData(),
  });

  const operations = operationsData?.data || {};

  const stats = {
    teams: operations.teams || operations.totalTeams || 0,
    activeTasks: operations.activeTasks || operations.activeOrders || 0,
    reportsGenerated: operations.reportsGenerated || operations.totalReports || 0,
  };

  if (isLoading) {
    return (
      <div className="space-y-6">
        <div className="bg-gradient-to-r from-violet-500 to-purple-600 rounded-xl p-6 text-white">
          <h1 className="text-3xl font-bold mb-2">Supervisor Dashboard</h1>
          <p className="text-white/80">Team oversight and quality control</p>
        </div>
        <div className="flex items-center justify-center py-12">
          <div className="w-16 h-16 border-4 border-violet-500 border-t-transparent rounded-full spinner"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-violet-500 to-purple-600 rounded-xl p-6 text-white">
        <h1 className="text-3xl font-bold mb-2">Supervisor Dashboard</h1>
        <p className="text-white/80">Team oversight and quality control</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600 mb-1">Teams</p>
              <p className="text-2xl font-bold text-gray-900">{stats.teams}</p>
            </div>
            <Users size={24} className="text-violet-600" />
          </div>
        </div>
        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600 mb-1">Active Tasks</p>
              <p className="text-2xl font-bold text-gray-900">{stats.activeTasks}</p>
            </div>
            <BarChart3 size={24} className="text-purple-600" />
          </div>
        </div>
        <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600 mb-1">Reports Generated</p>
              <p className="text-2xl font-bold text-gray-900">{stats.reportsGenerated}</p>
            </div>
            <FileText size={24} className="text-blue-600" />
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200">
        <h2 className="text-xl font-bold text-gray-900 mb-4">Quick Actions</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <button 
            onClick={() => navigate('/supervisor/operations')}
            className="px-4 py-3 bg-violet-500 text-white rounded-lg hover:bg-violet-600"
          >
            View Operations
          </button>
          <button 
            onClick={() => navigate('/supervisor/reports')}
            className="px-4 py-3 bg-purple-500 text-white rounded-lg hover:bg-purple-600"
          >
            Generate Reports
          </button>
        </div>
      </div>
    </div>
  );
};

export default SupervisorDashboard;

